import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "style", "className", "showText", "percent", "format", "strokeWidth", "width", "status"];
import React from 'react';
import { IconProgress } from './utils';
import "./style/index.css";
import "./style/line.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class Line extends React.Component {
  render() {
    var _this$props = this.props,
      {
        prefixCls,
        style,
        className,
        showText,
        percent,
        format,
        strokeWidth,
        status
      } = _this$props,
      resetProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var cls = [prefixCls, className, prefixCls + "-line", showText ? prefixCls + "-show-text" : null, status ? prefixCls + "-status-" + status : null, parseInt(percent.toString(), 10) >= 100 ? prefixCls + "-status-success" : null].filter(Boolean).join(' ').trim();
    var progressInfo;
    if (showText) {
      var progressStatus = parseInt(percent.toString(), 10) >= 100 && !('status' in this.props) ? 'success' : status;
      var percentView = percent + "%";
      if (progressStatus === 'exception') {
        percentView = /*#__PURE__*/_jsx(IconProgress, {
          type: "circle-close"
        });
      } else if (progressStatus === 'success') {
        percentView = /*#__PURE__*/_jsx(IconProgress, {
          type: "circle-check"
        });
      }
      progressInfo = /*#__PURE__*/_jsx("span", {
        className: prefixCls + "-text",
        children: format ? format(percent) : percentView
      });
    }
    var percentStyle = {
      width: percent + "%",
      height: strokeWidth
    };
    return /*#__PURE__*/_jsxs("div", _extends({
      className: cls,
      style: style
    }, resetProps, {
      children: [/*#__PURE__*/_jsx("div", {
        className: prefixCls + "-bar",
        children: /*#__PURE__*/_jsx("div", {
          className: prefixCls + "-inner",
          children: /*#__PURE__*/_jsx("div", {
            className: prefixCls + "-bg",
            style: percentStyle
          })
        })
      }), progressInfo]
    }));
  }
}
Line.defaultProps = {
  prefixCls: 'w-progress',
  showText: true,
  // 是否显示进度条文字内容
  percent: 0,
  // 百分比（必填）
  width: 126,
  // 圆圈进度条画布宽度
  strokeWidth: 6 // 进度条大小设置
};

export { Line };